import React from "react";

export const Loading = () => (
  <div className="d-flex align-items-center">
    <div className="ml-auto mr-auto spinner-border" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);
Loading.displayName = "Loading";
